<script setup lang="ts">
import { ElTooltip } from 'element-plus'
const props = withDefaults(
  defineProps<{
    effect?: 'dark' | 'light'
    rawContent?: boolean
    trigger?: 'hover' | 'click' | 'focus' | 'contextmenu'
    disabled?: boolean
    autoClose?: number
    showArrow?: boolean
    zIndex?: number
    placement?:
      | 'top'
      | 'top-start'
      | 'top-end'
      | 'bottom'
      | 'bottom-start'
      | 'bottom-end'
      | 'left'
      | 'left-start'
      | 'left-end'
      | 'right'
      | 'right-start'
      | 'right-end'
  }>(),
  {
    autoClose: 0,
    disabled: false,
    rawContent: true,
    showArrow: true,
    effect: 'light',
    trigger: 'hover',
    placement: 'bottom',
  },
)
defineSlots<{ content(): void; default(): void }>()
</script>
<template>
  <div>
    <ElTooltip v-bind="props">
      <slot name="default" />
      <template #content>
        <div class="tooltip__container">
          <slot name="content" />
        </div>
      </template>
    </ElTooltip>
  </div>
</template>
<style lang="scss" scoped>
.tooltip__container {
  max-width: 280px;
}
</style>
